import React from 'react';
import ParentCreateAccount from '../domains/parent/components/ParentCreateAccount';

const ParentCreateAccountPage: React.FC = () => {
  return <ParentCreateAccount />;
};

export default ParentCreateAccountPage;